
import React from 'react';
import { Button } from '@/components/ui/button';

interface BillingToggleProps {
  billingCycle: 'monthly' | 'yearly';
  onToggle: (cycle: 'monthly' | 'yearly') => void;
}

const BillingToggle: React.FC<BillingToggleProps> = ({ billingCycle, onToggle }) => {
  const monthlyCost = 5;
  const yearlyCost = 60;
  const monthlyEquivalent = monthlyCost * 12;
  const isYearlySame = monthlyEquivalent === yearlyCost;
  
  return (
    <div className="flex flex-col items-center justify-center mb-8">
      <h3 className="text-lg font-semibold mb-4 text-gray-700">Choose Your Billing Cycle</h3>
      <div className="relative bg-gray-100 rounded-full p-1 flex items-center shadow-inner border">
        {/* Sliding background indicator */}
        <div
          className={`absolute top-1 bottom-1 bg-white rounded-full shadow-md transition-all duration-300 ease-in-out ${
            billingCycle === 'monthly' 
              ? 'left-1 w-[calc(50%-4px)]' 
              : 'left-[calc(50%+2px)] w-[calc(50%-4px)]'
          }`}
        />
        
        {/* Monthly option */}
        <button
          onClick={() => onToggle('monthly')}
          className={`relative z-10 px-6 py-3 rounded-full transition-colors duration-300 min-w-[120px] flex flex-col items-center ${
            billingCycle === 'monthly' 
              ? 'text-[#FF8C00] font-semibold' 
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          <span className="text-sm font-medium">Monthly</span>
          <span className="text-xs opacity-75 mt-1">$5/month</span>
        </button>
        
        {/* Yearly option */}
        <button
          onClick={() => onToggle('yearly')}
          className={`relative z-10 px-6 py-3 rounded-full transition-colors duration-300 min-w-[120px] flex flex-col items-center ${
            billingCycle === 'yearly' 
              ? 'text-[#FF8C00] font-semibold' 
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">Yearly</span>
            {isYearlySame && (
              <span className="text-xs bg-blue-500 text-white px-2 py-0.5 rounded-full">
                Same Rate
              </span>
            )}
          </div>
          <span className="text-xs opacity-75 mt-1">$60/year</span>
        </button>
      </div>
      
      {billingCycle === 'yearly' && (
        <p className="text-sm text-gray-600 mt-3 text-center">
          Pay once per year • Same great value
        </p>
      )}
    </div>
  );
};

export default BillingToggle;
